import 'core-js/es/promise'
import 'core-js/es/string'
import 'core-js/es/array'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import dict from './dict'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

Vue.use(VModal)

Vue.use(Notifications, { velocity })

VeeValidate.Validator.localize('en', dict)

Vue.use(VeeValidate, {fieldsBagName: 'formFields'})

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
